import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetTermsAndConditions } from "../../../Services/BON-Frontend/Service";

export const fetchFrontTermsAndConditions = createAsyncThunk(
  "frontTerms/fetchFrontTermsAndConditions",
  async (PropertyID, { rejectWithValue }) => {
    try {
      const response = await GetTermsAndConditions(PropertyID);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const frontTermsSlice = createSlice({
  name: "frontTerms",
  initialState: {
    terms: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFrontTermsAndConditions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFrontTermsAndConditions.fulfilled, (state, action) => {
        state.loading = false;
        state.terms = action.payload || [];
      })
      .addCase(fetchFrontTermsAndConditions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default frontTermsSlice.reducer;
